import React from 'react';
import SimplePage from '../../pages/SimplePage';

export default function CertificatesPage() {
  return <SimplePage title="Certificates" subtitle="Search, view, and manage certificates." />;
}
